
export function useDescription() {
  const descriptionGlobal = [
    'Showing long-term development of Crop Commodity Prices: Current vs. different historical periods of time',
    'Source: ICE, NYSE, USDA Prices, FAO International Commodity Prices',
  ];
  return descriptionGlobal;
}